(ns bec-cljs-common.pushyme
  "Simple integration with https://pushy.me/.
  Also see bec-clj-common.pushyme."
  (:require [taoensso.timbre :as log]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [ajax.core :as ajax :refer [json-request-format json-response-format]]
            [bec-cljs-common.config :as config]
            [bec-cljs-common.re-frame :as bcc.rf]))


;; TODO: This stuff needs some retry logic. Possibly for js/Pushy register, and certainly for the callback that passes `device-id` our app server.
(defn register! [app-id]
  (-> (. js/Pushy register #js {:appId app-id})
      (.then (fn [device-id]
               (try
                 (log/info 'register! {:device-id device-id})
                 (rf/dispatch [::bcc.rf/xhrio
                               {:method :put
                                :uri (str config/app-server-url "/bec-clj-common/pushyme/device/" device-id)}])
                 (catch :default ex
                   (log/error ex)))))))


(defn unregister! [device-id]
  (log/info 'unregister! {:device-id device-id})
  (rf/dispatch [::bcc.rf/xhrio {:method :delete, :uri (str config/app-server-url "/bec-clj-common/pushyme/device/" device-id)}]))
